module.exports = __webpack_public_path__ + "img/course-icon-down.68beb379.svg";